/**
 * DBS Chevron hover
 */
jQuery(window).on('load', function () {
	jQuery('#dbs-chev').on('focus', function(){
		jQuery(this).addClass('show-additional-content');
	});
	jQuery('#dbs-chev').on('focusout', function(){
		jQuery(this).removeClass('show-additional-content');
	});
	jQuery('#dbs-chev').on('keydown', function (e) {
		if ( e.keyCode == 27 ) { // escape key maps to keycode `27`
			jQuery(this).removeClass('show-additional-content');
		}
	});
});
